import { FC } from 'react';

import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import { DetailedTransaction } from 'features/Bank/pages/Overview/Sidebar/hooks/useDetailedTransactionQuery';
import * as workRoutes from 'features/Work/routes';

import useUnlinkInvoiceMutation from '../../../../../../hooks/useUnlinkInvoiceMutation';
import BaseAttachmentCard from '../BaseAttachmentCard';
import locales from './locales';

interface InvoiceAttachmentCardProps {
  invoiceId: string;
  fiscalId: string;
  transactionId: string;
  transactionType: DetailedTransaction['type'];
  canUnlink?: boolean;
}

const InvoiceAttachmentCard: FC<InvoiceAttachmentCardProps> = ({
  canUnlink = true,
  fiscalId,
  invoiceId,
  transactionId,
  transactionType,
}) => {
  const [unlinkInvoice, { loading }] = useUnlinkInvoiceMutation({
    transactionId,
    transactionType,
  });

  return (
    <BaseAttachmentCard
      deleteLabel={locales.unlink}
      isDeleting={loading}
      linkTo={{
        pathname: workRoutes.getInvoice(invoiceId),
        state: {
          from: 'transaction-details',
        },
      }}
      onDelete={canUnlink ? () => unlinkInvoice(invoiceId) : undefined}
      title={locales.formatString(locales.title, { fiscalId })}
    >
      <SquircleIcon name="invoice" />
    </BaseAttachmentCard>
  );
};

export default InvoiceAttachmentCard;
